module.exports = __webpack_public_path__ + "img/FE2AC77F-4138-48B9-B61C-F81C6047E23A.19e094c0.png";